<template>

  <div class="cws-container">

    <div class="cws-sidebar">
      <slot name="sidebar" />
    </div>

    <div class="cws-main">
      <slot />
    </div>

  </div>

</template>

<script setup lang="ts">

</script>

<style scoped lang="scss">

@use 'sass:map';
@use '../styles/settings';

.cws-container {

  @media (map.get(settings.$display-breakpoints, 'md-and-down')) {

    .cws-sidebar {
      margin-bottom: 30px;
    }

  }

  @media (map.get(settings.$display-breakpoints, 'lg-and-up')) {

    display: flex;

    .cws-sidebar {
      width: 328px; // default height of VDatePicker
    }

    .cws-main {
      margin-left: 30px;
      width: 100%;
    }

  }

}

</style>
